import { Button } from '@cian/ui-kit/button';
import { Spinner } from '@cian/ui-kit/loader';
import { Skeleton } from '@cian/ui-kit/skeleton';
import { ArticleHeading3, Body2 } from '@cian/ui-kit/typography';
import type { ReactNode, Ref } from 'react';

import style from './style.css';

export interface IBuildingOffersProps {
  sectionRef?: Ref<HTMLElement>;
  /** Сделка, тип и вкладки */
  filters: ReactNode;
  children: ReactNode;
}

/** Секция «Предложения» (`#all-offers`) */
export const BuildingOffers = ({ sectionRef, filters, children }: IBuildingOffersProps) => (
  <section ref={sectionRef} className={style['section']} id="all-offers" data-name="BuildingOffers">
    <div className={style['container']}>
      <ArticleHeading3 as="h2">Предложения</ArticleHeading3>
      <div className={style['panel']}>
        {filters}
        {children}
      </div>
    </div>
  </section>
);

/** До первого ответа — место таблицы и превью, чтобы страница не прыгала */
export const OffersSkeleton = () => (
  <div className={style['skeleton']} data-name="OffersSkeleton">
    <Skeleton width="100%" height={460} />
    <Skeleton width="100%" height={460} />
  </div>
);

export const OffersError = ({ onRetry }: { onRetry(): void }) => (
  <div className={style['error']} data-name="OffersError">
    <Body2>При загрузке предложений возникла ошибка.</Body2>
    <Button theme="main_secondary" size="XS" onClick={onRetry}>
      Попробовать снова
    </Button>
  </div>
);

export interface IOffersContentProps {
  table: ReactNode;
  preview: ReactNode;
  /** Середина выбранной строки — сюда указывает стрелка превью */
  arrowTop: number | null;
  /** Загрузка дольше порога: старые данные под оверлеем с лоадером */
  isLoading: boolean;
}

/** Таблица слева, превью выбранного объявления справа */
export const OffersContent = ({ table, preview, arrowTop, isLoading }: IOffersContentProps) => (
  <div className={style['content']}>
    {table}
    <div className={style['preview']}>
      {arrowTop !== null && <span className={style['arrow']} style={{ top: arrowTop }} />}
      {preview}
    </div>
    {isLoading && (
      <div className={style['overlay']} data-name="OffersLoading">
        <Spinner size={32} />
      </div>
    )}
  </div>
);
